import usePush from './usePush';

const usePushForgotPassword = () => {
  const pushPath = usePush();

  const pushForgotPassword = () => {
    pushPath('/forgotPassword');
  };

  return pushForgotPassword;
};

export default usePushForgotPassword;
